<!--<div class="db-demo-blk-banner" *ngIf="!paidFeature">
  <p>30% off your first payment – Black Friday special!<br class="mobile"/> <span class="ml4">Exclusive holiday offer ends soon.</span></p>
</div>-->

<div class="db-one-week-free-demo">
    <div class="db-one-week-free-demo__header">
        <div class="db-one-week-free-demo__header-title">
          <h1>Try Pro plans for Free</h1>
          <div class="db-pricing-tabs">
            <div class="db-tab" [ngClass]="{'db-active': activeTab === 'ecommerce'}"
                 *ngIf=" (currentSubscription?.trialClient || [UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM].includes(currentSubscription?.type))"
                 (click)="openTab('ecommerce')">
              <span>Ecommerce</span></div>

            <div class="db-tab" [ngClass]="{'db-active': activeTab === 'agency'}"
                 *ngIf="(currentSubscription?.trialClient || [UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM].includes(currentSubscription?.type))"
                 (click)="openTab('agency')">
              <span>Agency (3+ sites)</span></div>
          </div>
        </div>
      <div class="db-tabs-with-period-switch">
        <p *ngIf="currentSubscription?.hasActiveDomainAgreement">Try 10Web Pro plans for free for 7 days.<br/>Personalize your online store, add your products, and start selling.</p>
        <p *ngIf="!currentSubscription?.hasActiveDomainAgreement">Get 7 days of 10Web Pro Plans and
         a custom <br class="db-hide-mobile"/>domain for Free <br class="db-hide-desktop"/>
          Personalize your online store,<br class="db-hide-mobile"/> add your products, and start selling.</p>
        <div class="db-period-switch-coupon db-upgrade-plan__period-switch">
          <db-plan-period-switch
            [isEcommerceWebsite]="isEcommerceWebsite"
            [dontChangeSwitchValue]="true"
            [user]="user" [formControl]="periodSwitch"
            [currentSubscription]="currentSubscription"
            [uppercaseTitle]="false" [small]="true"
            [newPrice]="true"></db-plan-period-switch>
        </div>
      </div>
    </div>
    <div class="db-one-week-free-demo__container">
        <div class="db-one-week-free-demo__content {{activeTab}}">
            <ng-container *ngIf="subscriptionsTabs && subscriptionsTabs[activeTab]">
                <ng-container *ngFor="let subscription of subscriptionsTabs[activeTab]">
                    <db-one-week-free-demo-ecommerce-option
                            [ngClass]="{'hidden': subscription?.plan?.periodNumber !== periodSwitch?.value, 'visible': subscription?.plan?.periodNumber === periodSwitch?.value}"
                            [title]="subscription?.plan?.title"
                            [applyCouponForPlatform] = "applyCouponForPlatform"
                            [couponPercent] = "couponPercent"
                            [hasFreeDays] = "hasFreeDays"
                            [domainName] = "domainName"
                            [description]="planFeatures[activeTab][subscription?.category]?.desc"
                            [subscription]="subscription"
                            [availableSubscriptions]="subscriptionsTabs[activeTab]"
                            [periodSwitchValue]="periodSwitch?.value"
                            [paidFeature]="paidFeature"
                            [plan]="planFeatures[activeTab][subscription?.category]?.planInfo"
                            [planDesc]="planFeatures[activeTab][subscription?.category]?.planInfoDesc"
                            [mostPopular]="!!planFeatures[activeTab][subscription?.category]?.mostPopular"
                            [professionalInfo]="!!planFeatures[activeTab][subscription?.category]?.info"
                            [isAgency]="activeTab === 'agency'"
                            [activeTab]="activeTab"
                            [customDomainFlow]="customDomainFlow"
                            (onStepChange)="chooseSubscr(subscription, subscription.couponCode); onStepChange.emit('checkout'); resizeToNormal()"
                    ></db-one-week-free-demo-ecommerce-option>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
